export default {
    getSelectedSettingsSidemenu(state) {
        return state.selectedSettingsSidemenu;
    },
    getExternalPluginInfo(state) {
        return state.externalPluginInfo;
    }
};